import { createRemittanceConfig } from "cy-remittance-config";

/**
 * Cymonz remittance configuration.
 *
 * Note: Cymonz is a demo/internal site used for testing and development.
 * The placeholder contact details below are intentional and should be
 * replaced with real values if Cymonz is ever used as a production site.
 */
export const remittanceConfig = createRemittanceConfig({
  companyName: "Cymonz",
  shortCompanyName: "Cymonz",
  contactDetails: {
    supportEmail: "help@cymonz.com",
    supportPhone: {
      display: "+27 00 000 0000", // Placeholder for demo site
      value: "+27000000000",
    },
    infoEmail: "info@cymonz.com",
    whatsappNumber: "000 000 0000", // Placeholder for demo site
  },
});
